import {FC} from 'react'
import s from '../../style.module.css'
import Image from 'next/image'

const dimension = {
  width: 85,
  height: 85,
}

interface Props {
  hideDominoMenu: () => void
}

const RetryBtn: FC<Props> = ({hideDominoMenu}) => {
  const imgSrc = 'https://static.gamezop.com/comet/assets/img/game-player/retry.png'
  const handleRetry = () => {
    // gameInitDetails will always be these values
    const gameInitDetails = {
      matchId: 'matchId',
      players: [],
    }
    const game = document.getElementById('game') as HTMLIFrameElement
    game.contentWindow?.gamezop.gameInit(gameInitDetails)
    hideDominoMenu()
  }

  return (
    <button className={s.retry_btn} onClick={handleRetry}>
      <Image src={imgSrc} {...dimension} alt='Retry' />
    </button>
  )
}

export default RetryBtn
